import React from 'react';
import classnames from 'classnames';
import './tooltip.styl';

import { is768Query } from '../../mediaquery-helper';
import { numberFormat } from '../../utils';

const Tooltip = props => {
  const isSmallScreen = !is768Query()
  const style = isSmallScreen ? {} : { left: `${props.pos.x + 15}px`, top: `${props.pos.y - 75}px` };
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': props.visible });

  return (
    <div className={tooltipClass} style={style}>
      <div className="tooltip">
        <div className="close">X</div>
        <div className="tooltip-header location">Tooltip</div>
        <div className="tooltip-light kiezname">{props.data.district}</div>
        <div className="tooltip-item">{props.data.name}</div>
        <div className="tooltip-item">{numberFormat(12.455)}</div>
      </div>
    </div>
  );
};

export default Tooltip;
